import { Injectable } from '@angular/core'

import { ResourceSlug } from '../../../shared/enums/wordpress/wp-resource-slug.enum'
import { ExternalLink } from '../../../shared/interfaces/resources/external-link.interface'
import { WPExternalLink } from '../../../shared/interfaces/wordpress/wp-external-link.interface'

import { BlogResourceService } from '../../../shared/services/blog-resource.service'
import { FormatResourceService } from '../../../shared/services/format-resource.service'

@Injectable({
  providedIn: 'root'
})
export class ExternalLinkService {
  constructor(
    private blogResourceService: BlogResourceService,
    private formatResourceService: FormatResourceService
  ) {}

  list(listParams: { ids?: number[] }): Promise<ExternalLink[]> {
    const params: { [key: string]: any } = {}

    if (listParams.ids) {
      params.include = listParams.ids.join()
    }
    params.withoutPagination = true
    params._embed = 1

    return (
      this.blogResourceService.list(
        ResourceSlug.ExternalLink,
        params
      ) as Promise<WPExternalLink[]>
    ).then((wpExternalLinkRes: WPExternalLink[]) => {
      return wpExternalLinkRes.map((wpEL) =>
        this.formatResourceService.formatExternalLink(wpEL)
      )
    })
  }
}
